import { Alert, AlertDescription } from '@/components/ui/alert';
import { formatEuros } from '@/lib/format';
import { RegimeComparatorForm } from '@/features/simulations/RegimeComparatorForm';
import { SavedSimulations } from '@/features/simulations/SavedSimulations';
import { SimulateurTabs } from '@/features/simulations/SimulateurTabs';
import { computeRegimeComparison, engineOf } from '@/features/simulations/engine';
import { FR_REGIME_LABELS } from '@/features/simulations/labels';

export function SimulateurPage() {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Simulateur</h1>
      <SimulateurTabs />
      <Alert>
        <AlertDescription>
          Modèle indicatif, à faire valider par votre comptable. Le comparateur reproduit la
          première année seulement ; la plus-value est calculée mais pas imposée ici.
        </AlertDescription>
      </Alert>
      <RegimeComparatorForm />
      <SavedSimulations
        kind="regime-comparison"
        renderHeadline={(simulation) => {
          const comparison = computeRegimeComparison(simulation.input, engineOf(simulation.engineVersion));
          const eligible = Object.values(comparison.regimes).filter((r) => r.eligible);
          const best = eligible.reduce((a, b) => (b.cashInPocket > a.cashInPocket ? b : a));
          return (
            <span>
              Meilleur régime : {FR_REGIME_LABELS[best.regime]} ({formatEuros(best.cashInPocket)})
            </span>
          );
        }}
      />
    </div>
  );
}
